import { render, staticRenderFns } from "./AlignInput.vue?vue&type=template&id=da7f9082&scoped=true"
import script from "./AlignInput.vue?vue&type=script&lang=js"
export * from "./AlignInput.vue?vue&type=script&lang=js"
import style0 from "./AlignInput.vue?vue&type=style&index=0&id=da7f9082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7f9082",
  null
  
)

export default component.exports